import React from 'react';
import { TouchableOpacity ,StyleSheet} from 'react-native';
import Theme from '../../theme';

const Tile = ({ children, onPress, customStyle = {} })  => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.tileContainer,
        customStyle
        ]}>
        {children}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  tileContainer: {
    flexDirection: 'row',
    backgroundColor: Theme.GREY_DARK,
    marginBottom: 7.5,
    borderRadius: 2
  },
})
export default Tile;
